import React, { useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import svgIcons from "uikit/assets/svgIcons";
import styles from "./Avatar.module.styl";

function AvatarContent({
    uri,
    imageFailed,
    abbrParts,
    sizeClass,
    shapeClass,
    backgroundClass,
    sexIconClass,
    imageLoaded,
    setImageLoaded,
    setImageFailed,
    sex,
}) {
    if (uri && !imageFailed) {
        return (
            <img
                className={cx(
                    styles.avatarImg,
                    sizeClass,
                    shapeClass,
                    !imageLoaded && styles.hidden,
                )}
                src={uri}
                alt=""
                onLoad={() => setImageLoaded(true)}
                onError={() => setImageFailed(true)}
            />
        );
    }

    const abbr = abbrParts && abbrParts.length > 0 ? abbrParts.map((p) => p[0] || "").join("") : "";

    let defaultImage = svgIcons.image;

    switch (sex) {
        case "None":
            break;
        case "Male":
            defaultImage = svgIcons.male;
            break;
        case "Female":
            defaultImage = svgIcons.female;
            break;
        default:
            break;
    }

    return (
        <div className={cx(styles.noAvatar, sizeClass, shapeClass, backgroundClass)}>
            {abbr ? (
                <span className={styles.abbr}>{abbr}</span>
            ) : (
                <div className={cx(sexIconClass)}>{defaultImage}</div>
            )}
        </div>
    );
}

export default function Avatar({
    uri,
    abbrParts,
    size,
    shape,
    background,
    className,
    sex,
    dataTestName,
}) {
    const sizeClass = styles["size_" + size];
    const shapeClass = styles["shape_" + shape];
    const backgroundClass = styles["background_" + background];
    const sexIconClass = styles["sexIcon_" + size];

    const rootClass = cx(styles.avatar, className);

    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageFailed, setImageFailed] = useState(false);

    return (
        <div className={rootClass} data-test-name={dataTestName}>
            <AvatarContent
                uri={uri}
                imageFailed={imageFailed}
                abbrParts={abbrParts}
                sizeClass={sizeClass}
                shapeClass={shapeClass}
                backgroundClass={backgroundClass}
                sexIconClass={sexIconClass}
                imageLoaded={imageLoaded}
                setImageLoaded={setImageLoaded}
                setImageFailed={setImageFailed}
                sex={sex}
            />
        </div>
    );
}

Avatar.propTypes = {
    uri: PropTypes.string,
    abbrParts: PropTypes.array,

    size: PropTypes.oneOf(["small", "medium", "big", "large", "x_large"]),

    shape: PropTypes.oneOf(["circle", "rounded"]),

    background: PropTypes.oneOf(["grey", "white"]),

    sex: PropTypes.oneOf(["None", "Male", "Female"]),

    className: PropTypes.string,
    dataTestName: PropTypes.string,
};

Avatar.defaultProps = {
    size: "medium",
    shape: "rounded",
    background: "grey",
    sex: "None",
};
